import { userRole, checkAvailabilityRole } from 'helpers/user';
import { lsGetLoginType } from 'helpers/store';

export default {
  async checkAuthAndRole(to, from, next) {
    const userRoles = await userRole();
    const pageRoles = to.meta.roles;

    if (!userRoles) return next({ name: lsGetLoginType() || 'loginEmployees' });

    if (pageRoles && checkAvailabilityRole(userRoles, pageRoles)) {
      next();
    } else {
      next({ name: 'access-denied' });
    }
  }
};
